'use client';

import { Body, Display } from '@depop/web-thrift-ui/Typography';
import clsx from 'clsx';
import { useTranslations } from 'next-intl';

import { RedemptionButton } from '../RedemptionButton';

import styles from './styles.module.css';

import { type PartnerDisplay } from '@/modules/partners/types';

type Props = {
  features: PartnerDisplay['features'];
  name: string;
  redemptionLink: string;
  cloudfrontHost: string;
};

export function Features({
  features,
  name,
  redemptionLink,
  cloudfrontHost,
}: Props) {
  const t = useTranslations('partners');

  return (
    <section className={clsx(styles.section, styles.featuresSection)}>
      {features.map((feature, index) => {
        const count = index + 1;
        return (
          <div
            className={clsx(styles.card, {
              [styles.cardReverse]: index % 2 === 0,
            })}
            key={index}
          >
            <div className={styles.cardContent}>
              <Display>{t(`Partners.${name}.FeaturesTitle${count}`)}</Display>
              <Body variant="sm-regular">
                {t(`Partners.${name}.FeaturesDesc${count}`)}
              </Body>
              <RedemptionButton
                ctaText={t(`Partners.${name}.ButtonTitle${count}`)}
                redemptionLink={
                  feature.overrideLink ? feature.overrideLink : redemptionLink
                }
              />
            </div>
            <div className={styles.cardImage}>
              <img
                className={styles.displayImage}
                src={`${cloudfrontHost}/web/assets/partners/${feature.image}`}
                srcSet={`${cloudfrontHost}/web/assets/partners/${feature.image}`}
                // eslint-disable-next-line no-restricted-syntax
                data-testid="feature-image"
                alt=""
              />
            </div>
          </div>
        );
      })}
    </section>
  );
}
